var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("b-loading", {
        attrs: {
          "is-full-page": _vm.isFullPage,
          active: _vm.isLoading,
          "can-cancel": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sidebar sidebar-fixed bg-white",
          attrs: { id: "sidebarMenu" }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sidebar-body" },
            [
              _vm._l(_vm.inputSearchForms, function(form, i) {
                return form.division === "C"
                  ? _c("ul", { staticClass: "sidebar-nav" }, [
                      i === 0
                        ? _c("li", { staticClass: "nav-label mg-b-10-f" }, [
                            _vm._v(" ")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "d-block has-text-weight-semibold",
                            attrs: { for: form.id }
                          },
                          [_vm._v(_vm._s(form.name))]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "mg-b-0 text-left" }, [
                          _vm._v(_vm._s(_vm.orderData[form.id]))
                        ])
                      ])
                    ])
                  : form.division === "O"
                  ? _c("ul", { staticClass: "sidebar-nav" }, [
                      i === 0
                        ? _c("li", { staticClass: "nav-label mg-b-10-f" }, [
                            _vm._v(" ")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "d-block has-text-weight-semibold",
                            attrs: { for: "formGroupExampleInput" }
                          },
                          [_vm._v(_vm._s(form.name))]
                        ),
                        _vm._v(" "),
                        form.value.length > 0
                          ? _c(
                              "p",
                              { staticClass: "mg-b-0 text-left" },
                              _vm._l(form.value, function(form1, i) {
                                return form1.codeCode == _vm.orderData[form.id]
                                  ? _c("span", [_vm._v(_vm._s(form1.codeName))])
                                  : _vm._e()
                              }),
                              0
                            )
                          : _c("p", { staticClass: "mg-b-0 text-left" }, [
                              _vm._v(_vm._s(_vm.orderData[form.id]))
                            ])
                      ])
                    ])
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm._l(_vm.checkboxSearchForms, function(form, i) {
                return _c("ul", { staticClass: "sidebar-nav" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: " d-block has-text-weight-semibold",
                          attrs: { for: "formGroupExampleInput" }
                        },
                        [_vm._v(_vm._s(form.name))]
                      ),
                      _vm._v(" "),
                      _vm._l(form.value, function(form1, i) {
                        return _c(
                          "div",
                          {
                            staticClass: "ml-2 custom-control custom-radio mb-1"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.orderData[form.id],
                                  expression: "orderData[form.id]"
                                }
                              ],
                              staticClass: "custom-control-input",
                              attrs: {
                                type: "radio",
                                id: form1.codeCode,
                                name: form.id
                              },
                              domProps: {
                                value: form1.codeCode,
                                checked:
                                  form1.codeCode == _vm.orderData[form.id],
                                checked: _vm._q(
                                  _vm.orderData[form.id],
                                  form1.codeCode
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.orderData,
                                    form.id,
                                    form1.codeCode
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: form1.codeCode }
                              },
                              [_vm._v(_vm._s(form1.codeName))]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.dateSearchForms, function(form, i) {
                return _c("ul", { staticClass: "sidebar-nav" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "d-block has-text-weight-semibold",
                        attrs: { for: "formGroupExampleInput" }
                      },
                      [_vm._v(_vm._s(form.name))]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "mg-b-0 text-left" }, [
                      _vm._v(_vm._s(_vm.orderData[form.id]))
                    ])
                  ])
                ])
              })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content content-components" }, [
        _c("div", { staticClass: "pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
          _c(
            "div",
            {
              staticClass:
                "d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30"
            },
            [
              _c("div", [
                _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
                  _c(
                    "ol",
                    { staticClass: "breadcrumb breadcrumb-style1 mg-b-10" },
                    [
                      _c("li", { staticClass: "breadcrumb-item" }, [
                        _vm._v(_vm._s(this.mainName))
                      ]),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "breadcrumb-item",
                          attrs: { "aria-current": "page" }
                        },
                        [_vm._v(_vm._s(this.subName))]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "breadcrumb-item active",
                          attrs: { "aria-current": "page" }
                        },
                        [_vm._v("View")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "mg-b-0 tx-spacing--1" }, [
                    _vm._v(_vm._s(this.subName) + " View")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end"
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                      attrs: {
                        to: {
                          name: this.$route.name.replace("_completion", ""),
                          params: { mid: this.properties.mid, type: "list" }
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "wd-10 mg-r-5",
                        attrs: { "data-feather": "file" }
                      }),
                      _vm._v("list")
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: " pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
            _c("div", { staticClass: "col-sm-6 col-lg-5" }, [
              _c(
                "ul",
                {
                  staticClass: "cardborder nav nav-tabs",
                  attrs: { id: "myTab", role: "tablist" }
                },
                [
                  _c("li", { staticClass: "nav-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link active",
                        attrs: {
                          id: "experiment-tab",
                          "data-toggle": "tab",
                          href: "#experiment",
                          role: "tab",
                          "aria-controls": "experiment",
                          "aria-selected": "true"
                        },
                        on: { click: function($event) {} }
                      },
                      [_vm._v("Order")]
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card card-body" }, [
              _c(
                "div",
                {
                  staticClass: "tab-content mg-t-20",
                  attrs: { id: "myTabContent" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "tab-pane fade lm-overflow show active",
                      attrs: {
                        id: "experiment",
                        role: "tabpanel",
                        "aria-labelledby": "experiment-tab"
                      }
                    },
                    [
                      _c(
                        "ul",
                        {
                          staticClass: "nav nav-line",
                          attrs: { id: "myTab5", role: "tablist" }
                        },
                        _vm._l(_vm.tabHeader, function(form, i) {
                          return _vm.properties.mid === form.id
                            ? _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link active",
                                    attrs: {
                                      id: form.id,
                                      "data-toggle": "tab",
                                      href: "#",
                                      role: "tab",
                                      "aria-controls": "home",
                                      "aria-selected": "true"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.classifySampleHeader(form.id)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(form.menuName))]
                                )
                              ])
                            : _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link",
                                    attrs: {
                                      id: form.id,
                                      "data-toggle": "tab",
                                      href: "#",
                                      role: "tab",
                                      "aria-controls": "profile",
                                      "aria-selected": "false"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.classifySampleHeader(form.id)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(form.menuName))]
                                )
                              ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "card col-lg-8 col-xl-7 mg-b-20 mg-lg-b-25"
                        },
                        [
                          _c(
                            "section",
                            [
                              _c(
                                "b-table",
                                {
                                  attrs: {
                                    data: _vm.isEmpty ? [] : _vm.sampleData,
                                    hoverable: "",
                                    striped: ""
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(props) {
                                        return _vm._l(
                                          _vm.sampleHeader,
                                          function(form, i) {
                                            return i == 0
                                              ? _c(
                                                  "b-table-column",
                                                  {
                                                    key: i,
                                                    attrs: {
                                                      field: "No",
                                                      label: "No"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                  " +
                                                        _vm._s(props.row.no) +
                                                        "\n                                                "
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "b-table-column",
                                                  {
                                                    key: i,
                                                    attrs: {
                                                      field: form.columnCode,
                                                      label: form.columnName,
                                                      centered: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          props.row[
                                                            form.columnCode
                                                          ]
                                                        ) +
                                                        "\n                                                "
                                                    )
                                                  ]
                                                )
                                          }
                                        )
                                      }
                                    }
                                  ])
                                },
                                [
                                  _vm._v(" "),
                                  _c("template", { slot: "empty" }, [
                                    _c("section", { staticClass: "section" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "content has-text-grey has-text-centered"
                                        },
                                        [_c("p", [_vm._v("Nothing here.")])]
                                      )
                                    ])
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-header" }, [
      _c("h5", [_vm._v("Search")]),
      _vm._v(" "),
      _c("a", { attrs: { href: "", id: "sidebarMenuClose" } }, [
        _c("i", { attrs: { "data-feather": "x" } })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-692be3f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-692be3f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/OrderConfirmation/CompletionForm.vue
// module id = null
// module chunks = 